__turbopack_context__.v({
  "addToCartContainer": "MicroCart-module__Ug84zG__addToCartContainer",
  "blok-big-title": "MicroCart-module__Ug84zG__blok-big-title",
  "blok-subtitle": "MicroCart-module__Ug84zG__blok-subtitle",
  "blok-title": "MicroCart-module__Ug84zG__blok-title",
  "cart-container": "MicroCart-module__Ug84zG__cart-container",
  "container": "MicroCart-module__Ug84zG__container",
  "muted": "MicroCart-module__Ug84zG__muted",
  "shown": "MicroCart-module__Ug84zG__shown",
  "stickyAddToCart": "MicroCart-module__Ug84zG__stickyAddToCart",
});
